var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0a18 18 0 1018 18A18 18 0 0018 0zm4.144 25.41l-6.4-4.652a.877.877 0 01-.356-.7V7.837a.874.874 0 01.871-.871h3.478a.874.874 0 01.871.871v10l4.609 3.353a.87.87 0 01.189 1.219l-2.047 2.816a.877.877 0 01-1.215.185z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaging);
export default __webpack_public_path__ + "static/media/paging.2d6e118a8b3581fec16e343d4afd83d8.svg";
export { ForwardRef as ReactComponent };